import { graphql } from '@/generated/gql';

export const EXTENSION_CONVERSATION_QUERY = graphql(/* GraphQL */ `
  query ExtensionConversation($entityId: UUID!, $entityVariant: SvbrgConversationEntityVariant!) {
    sevenbridges {
      conversationSettings(entityId: $entityId, entityVariant: $entityVariant) {
        id
      }
    }
  }
`);
